import React from "react";

import { Tag } from "@samskip/frontend-components";
import { useTranslation } from "react-i18next";

import { QuoteStatus, QuoteStatusesLabel } from "@assets/constants";

type Props = {
  quoteStatus: QuoteStatus;
  className?: string;
};

const getStatusTagColor = (status: QuoteStatus) => {
  switch (status) {
    case QuoteStatus.Pending:
      return "warning";
    case QuoteStatus.ReadyForApproval:
      return "info";
    case QuoteStatus.Valid:
      return "success";
    case QuoteStatus.Expired:
      return "neutral-600";
    default:
      return "primary";
  }
};

const QuoteStatusTag = ({ quoteStatus, className }: Props) => {
  const { t } = useTranslation();
  return (
    <Tag
      className={className}
      color={getStatusTagColor(quoteStatus)}
      size="small"
    >
      {t(QuoteStatusesLabel[quoteStatus])}
    </Tag>
  );
};

export default QuoteStatusTag;
